import { useTranslation } from "react-i18next";
import { localDateTime } from "../../lib/datetime";

// رأس بطاقة طلب الانضمام: الصورة والاسم والبريد والدور ووقت الطلب.
export const RequestHeader = ({ request }) => {
  const { t } = useTranslation();
  return (
    <div className="flex items-start gap-4">
      {request.reference_face ? (
        <img
          src={request.reference_face}
          alt={request.name}
          data-testid={`request-face-${request.id}`}
          className="h-20 w-20 rounded-2xl border border-border/60 object-cover shadow-neu-sm"
        />
      ) : (
        <div className="h-20 w-20 rounded-2xl border border-border/60 shadow-neu-in" />
      )}
      <div className="min-w-0">
        <p className="truncate text-lg font-bold">{request.name}</p>
        <p className="truncate text-xs text-muted-foreground">{request.email}</p>
        <p className="mt-1 text-xs font-semibold text-primary">{t(`roles.${request.role}`)}</p>
        <p className="mt-1 font-mono text-[11px] text-muted-foreground">
          {t("requests.submittedAt")}: {localDateTime(request.created_at)}
        </p>
      </div>
    </div>
  );
};
